import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TabNavigation from '../../components/ui/TabNavigation';
import AudioPlayerBar from '../../components/ui/AudioPlayerBar';
import ChannelHeader from './components/ChannelHeader';
import ContentTabs from './components/ContentTabs';
import EpisodeCard from './components/EpisodeCard';
import ChannelSidebar from './components/ChannelSidebar';
import PlaylistSection from './components/PlaylistSection';
import AboutSection from './components/AboutSection';

const ChannelProfile = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('recent');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [currentAudio, setCurrentAudio] = useState(null);

  const channelData = {
    id: 'channel-001',
    name: 'Голос Острова',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_10698aacf-1764656196596.png",
    avatarAlt: 'Профессиональное фото ведущего радиоканала в студии с микрофоном и наушниками на фоне звукоизоляционных панелей',
    voiceDescription: 'Аутентичные размышления о жизни на острове, философии присутствия и медитативных практиках',
    subscriberCount: 12847,
    broadcastCount: 156,
    totalHours: 342,
    stats: {
      totalPlays: 487234,
      avgDuration: '45 минут',
      rating: 4.8,
      activity: 'Активен'
    },
    schedule: [
    { day: 'Понедельник', time: '19:00 - 20:30' },
    { day: 'Среда', time: '20:00 - 21:00' },
    { day: 'Пятница', time: '18:00 - 19:30' }],

    socialLinks: [
    { platform: 'Telegram', icon: 'Send', url: 'https://t.me/voiceofisland' },
    { platform: 'Instagram', icon: 'Instagram', url: 'https://instagram.com/voiceofisland' },
    { platform: 'YouTube', icon: 'Youtube', url: 'https://youtube.com/@voiceofisland' },
    { platform: 'VK', icon: 'Share2', url: 'https://vk.com/voiceofisland' }],

    fullDescription: `Добро пожаловать в пространство аутентичного голоса.\n\nЗдесь нет редакторов, алгоритмов и коммерческих интересов - только чистое звучание мыслей и переживаний человека, живущего на острове Ко Пханган.\n\nКаждый эфир - это путешествие в глубину присутствия, где философия встречается с практикой, а тишина становится частью разговора.\n\nМы говорим о том, что важно: о поиске себя, о жизни в гармонии с природой, о медитации как способе существования, о создании независимых медиа-пространств.\n\nПрисоединяйтесь к сообществу людей, которые ценят подлинность и глубину.`,
    tags: [
    'Философия',
    'Медитация',
    'Островная жизнь',
    'Осознанность',
    'Независимые медиа',
    'Аутентичность',
    'Саморазвитие',
    'Духовные практики'],

    achievements: [
    {
      title: 'Первый независимый радиоканал острова',
      description: 'Запущен в январе 2024 года'
    },
    {
      title: 'Более 10,000 подписчиков за первый год',
      description: 'Органический рост без рекламы'
    },
    {
      title: 'Топ-5 философских подкастов России',
      description: 'По версии слушателей в 2024 году'
    }],

    createdDate: '2024-01-15',
    language: 'Русский',
    frequency: '3 раза в неделю',
    location: 'Ко Пханган, Таиланд'
  };

  const recentEpisodes = [
  {
    id: 'ep-001',
    title: 'Философия тишины: Пространство между звуками',
    description: 'Размышления о роли тишины в современном мире и практики осознанного молчания',
    artwork: "https://images.unsplash.com/photo-1724209084978-9e0024262199",
    artworkAlt: 'Спокойный закат над тропическим островом с силуэтами пальм и отражением в воде',
    duration: 2700,
    publishDate: '2024-12-01',
    playCount: 8934,
    commentCount: 127,
    isBookmarked: false,
    audioUrl: 'https://example.com/audio/ep001.mp3'
  },
  {
    id: 'ep-002',
    title: 'Островная автономия: Создание независимых медиа',
    description: 'Как построить медиа-платформу без алгоритмов и редакторов, сохраняя аутентичность',
    artwork: "https://img.rocket.new/generatedImages/rocket_gen_img_10698aacf-1764656196596.png",
    artworkAlt: 'Современная радиостудия с профессиональным микрофоном и звукозаписывающим оборудованием',
    duration: 3240,
    publishDate: '2024-11-29',
    playCount: 7621,
    commentCount: 98,
    isBookmarked: true,
    audioUrl: 'https://example.com/audio/ep002.mp3'
  },
  {
    id: 'ep-003',
    title: 'Медитация присутствия: Практика здесь и сейчас',
    description: 'Глубокое погружение в практику осознанного присутствия с управляемой медитацией',
    artwork: "https://images.unsplash.com/photo-1681494957040-5451e2767627",
    artworkAlt: 'Человек медитирует на берегу океана на рассвете в позе лотоса',
    duration: 2160,
    publishDate: '2024-11-27',
    playCount: 9456,
    commentCount: 143,
    isBookmarked: false,
    audioUrl: 'https://example.com/audio/ep003.mp3'
  },
  {
    id: 'ep-004',
    title: 'Архитектура влияния: Голос как инструмент',
    description: 'Исследование того, как аутентичный голос создает настоящее влияние без манипуляций',
    artwork: "https://images.unsplash.com/photo-1734166065471-448adee91616",
    artworkAlt: 'Винтажный микрофон крупным планом в теплом студийном освещении',
    duration: 2880,
    publishDate: '2024-11-25',
    playCount: 6789,
    commentCount: 85,
    isBookmarked: false,
    audioUrl: 'https://example.com/audio/ep004.mp3'
  }];


  const popularEpisodes = [
  {
    id: 'ep-005',
    title: 'Жизнь без алгоритмов: Возвращение к себе',
    description: 'Как освободиться от диктата алгоритмов и вернуть контроль над своим вниманием',
    artwork: "https://img.rocket.new/generatedImages/rocket_gen_img_14142246e-1764709707951.png",
    artworkAlt: 'Аналоговое аудиооборудование и виниловые пластинки в винтажной студии',
    duration: 3600,
    publishDate: '2024-11-20',
    playCount: 15234,
    commentCount: 234,
    isBookmarked: true,
    audioUrl: 'https://example.com/audio/ep005.mp3'
  },
  {
    id: 'ep-006',
    title: 'Философия острова: Уроки изоляции',
    description: 'Что островная жизнь учит нас о границах, свободе и самодостаточности',
    artwork: "https://images.unsplash.com/photo-1691394789384-120e225a6b89",
    artworkAlt: 'Тропический остров с белым песком и бирюзовой водой с высоты птичьего полета',
    duration: 2940,
    publishDate: '2024-11-15',
    playCount: 13567,
    commentCount: 198,
    isBookmarked: false,
    audioUrl: 'https://example.com/audio/ep006.mp3'
  }];


  const playlists = [
  {
    id: 'playlist-001',
    title: 'Основы медитации',
    description: 'Серия эфиров для начинающих практиков осознанности',
    coverImage: "https://img.rocket.new/generatedImages/rocket_gen_img_120f91125-1764705270090.png",
    coverImageAlt: 'Спокойная сцена медитации с благовониями и свечами в минималистичном интерьере',
    episodeCount: 12,
    totalDuration: '8 часов 30 минут'
  },
  {
    id: 'playlist-002',
    title: 'Философские беседы',
    description: 'Глубокие размышления о жизни, смерти и смысле существования',
    coverImage: "https://images.unsplash.com/photo-1733796941503-b5988195aa97",
    coverImageAlt: 'Старинные книги по философии на деревянном столе с чашкой чая',
    episodeCount: 18,
    totalDuration: '12 часов 15 минут'
  },
  {
    id: 'playlist-003',
    title: 'Островные истории',
    description: 'Рассказы о жизни на Ко Пхангане и встречах с интересными людьми',
    coverImage: "https://images.unsplash.com/photo-1673985869530-2cef353bc4a2",
    coverImageAlt: 'Живописный вид на тропический пляж с пальмами на закате',
    episodeCount: 24,
    totalDuration: '16 часов 45 минут'
  }];


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubscribe = () => {
    setIsSubscribed(!isSubscribed);
  };

  const handleNotificationToggle = () => {
    console.log('Настройки уведомлений');
  };

  const handlePlay = (episode) => {
    setCurrentAudio({
      url: episode?.audioUrl,
      title: episode?.title,
      artist: channelData?.name,
      artwork: episode?.artwork
    });
  };

  const handleDownload = (episode) => {
    console.log('Скачивание эпизода:', episode?.title);
  };

  const handleShare = (episode) => {
    console.log('Поделиться эпизодом:', episode?.title);
  };

  const handleBookmark = (episode) => {
    console.log('Добавить в закладки:', episode?.title);
  };

  const handleDonate = () => {
    console.log('Открыть форму доната');
  };

  const handlePlaylistClick = (playlist) => {
    console.log('Открыть плейлист:', playlist?.title);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'recent':
        return (
          <div className="episodes-list space-y-4">
            {recentEpisodes?.map((episode) =>
            <EpisodeCard
              key={episode?.id}
              episode={episode}
              onPlay={handlePlay}
              onDownload={handleDownload}
              onShare={handleShare}
              onBookmark={handleBookmark} />

            )}
          </div>);

      case 'popular':
        return (
          <div className="episodes-list space-y-4">
            {popularEpisodes?.map((episode) =>
            <EpisodeCard
              key={episode?.id}
              episode={episode}
              onPlay={handlePlay}
              onDownload={handleDownload}
              onShare={handleShare}
              onBookmark={handleBookmark} />

            )}
          </div>);

      case 'playlists':
        return (
          <PlaylistSection
            playlists={playlists}
            onPlaylistClick={handlePlaylistClick} />);


      case 'about':
        return <AboutSection channelData={channelData} />;
      default:
        return null;
    }
  };

  return (
    <div className="channel-profile-page min-h-screen bg-background">
      <TabNavigation />

      <ChannelHeader
        channelData={channelData}
        isSubscribed={isSubscribed}
        onSubscribe={handleSubscribe}
        onNotificationToggle={handleNotificationToggle} />


      <ContentTabs activeTab={activeTab} onTabChange={setActiveTab} />

      <div className="page-content max-w-7xl mx-auto px-6 py-8">
        <div className="content-grid grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="main-content lg:col-span-2">
            {renderTabContent()}
          </div>

          <div className="sidebar-content hidden lg:block">
            <ChannelSidebar channelData={channelData} onDonate={handleDonate} />
          </div>
        </div>
      </div>

      <div className="mobile-sidebar lg:hidden px-6 pb-24">
        <ChannelSidebar channelData={channelData} onDonate={handleDonate} />
      </div>

      <AudioPlayerBar
        audioSource={currentAudio}
        initialPlaybackState="paused"
        onPlayPause={() => {}}
        onSeek={() => {}}
        onVolumeChange={() => {}}
        onNext={() => {}}
        onPrevious={() => {}} />

    </div>);

};

export default ChannelProfile;